import * as React from 'react';

import { Link } from 'react-router-dom';

import { Tooltip } from '@mui/material';

import { colors } from 'theme';

import { ProductItemType } from '../../types';

import { IconContainer, Item } from './styles';

const ProductItem: React.FC<ProductItemType> = ({ name, tooltipTitle, Icon, ActiveIcon, isSelected, to, testId }) => (
  <Link
    to={to}
    style={{ textDecoration: 'none' }}
    id={`product-link-${name}`}
    key={`${name}_${isSelected}`}
    data-testid={testId ?? name}
  >
    <Tooltip
      title={tooltipTitle || name}
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            background: '#fff',
            color: '#000',
            padding: '4px 8px',
            fontSize: '14px',
            fontWeight: 500,
            boxShadow: colors.shadows.dropdown,
          },
        },
      }}
    >
      <Item $active={isSelected}>
        <IconContainer>
          <div>{isSelected ? ActiveIcon : Icon}</div>
        </IconContainer>
      </Item>
    </Tooltip>
  </Link>
);

export default ProductItem;
